import script from "./BotPreviewMessagingClientContainer.vue?vue&type=script&lang=ts&setup=true"
export * from "./BotPreviewMessagingClientContainer.vue?vue&type=script&lang=ts&setup=true"

import "./BotPreviewMessagingClientContainer.vue?vue&type=style&index=0&id=609a7c1e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-609a7c1e"]])

export default __exports__